import { CoparticipationTranslations } from '../models/coparticipation-translaction-model';

// eslint-disable-next-line import/prefer-default-export
export const enUS: CoparticipationTranslations = {
  title: 'Coparticipation',
  tabs: {
    statement: 'Coparticipation Query',
    reports: 'My Reports',
  },
  reports: {
    layoutName: 'Coparticipation Report',
  },
  filter: {
    expandSearch: 'Expand search',
    collapseSearch: 'Collapse search',
    clear: 'Clear filters',
    search: 'Search',
    financialGroup: 'Financial group',
    carrier: 'Carrier',
    contract: 'Contract',
    competence: 'Competence',
    beneficiary: 'Beneficiary',
    copayExempt: 'Exempt coparticipation',
    placeholders: {
      select: 'Select',
      competence: 'Select competence',
      beneficiary: 'Enter beneficiary',
    },
    copayExemptOptions: {
      all: 'All',
      yes: 'Yes',
      no: 'No',
    },
  },
  table: {
    headers: {
      carrier: 'Carrier',
      financialGroup: 'Financial Group',
      contract: 'Contract',
      subcontract: 'Subcontract',
      competence: 'Competence',
      beneficiary: 'Beneficiary',
      ownership: 'Ownership',
      plan: 'Plan',
      event: 'Event',
      eventDate: 'Event date',
      provider: 'Provider',
      copayAmount: 'Coparticipation amount',
      copayExempt: 'Exempt coparticipation',
      reason: 'Reason',
    },
    ownership: {
      holder: 'Holder',
      dependent: 'Dependent',
    },
    yes: 'Yes',
    no: 'No',
    loading: 'Loading records...',
    noData: 'No records found for the selected filters.',
    noResult: 'No results found.',
  },
  messages: {
    searchError: 'Error fetching coparticipation records.',
    requiredFilters: 'Fill Carrier, Financial Group, Contract and Competence to search.',
    exportError: 'Error exporting the coparticipation report.',
    forbiddenAccess: 'No permission to access the coparticipation statement.',
    noPermission: 'You do not have permission to access Coparticipation.',
  },
  actions: {
    export: 'Export',
  },
};
